import type { CSSProperties } from 'react'
import type { Category } from '../lib/supabase'
import { HAPTICS } from '../lib/constants'
import { haptic } from '../lib/haptics'

// The household's categories as pills, one picked: the item editor's Category
// field, and a recipe ingredient's (RecipeEditor, the import review).

export function CategoryPills({ categories, value, tintFor, onPick, label = 'Category', none }: {
  categories: Category[]
  value: string | null
  tintFor: (categoryId: string | null) => string
  onPick: (categoryId: string) => void
  label?: string
  /** A last pill for no category (Other), picked when `value` is null. */
  none?: { label: string; onPick: () => void }
}) {
  const ordered = [...categories].sort((a, b) => a.sort_order - b.sort_order)
  return (
    <div className="ml-editor__cats" role="radiogroup" aria-label={label}>
      {ordered.map(c => (
        <button key={c.id} type="button" role="radio" aria-checked={c.id === value}
          className={`ml-cat-pill${c.id === value ? ' is-selected' : ''}`}
          style={{ '--ml-tint': tintFor(c.id) } as CSSProperties}
          onClick={() => { haptic(HAPTICS.categoryPick); onPick(c.id) }}>
          <span className="ml-dot" aria-hidden="true" />
          {c.name}
        </button>
      ))}
      {none && (
        <button type="button" role="radio" aria-checked={value === null}
          className={`ml-cat-pill${value === null ? ' is-selected' : ''}`}
          style={{ '--ml-tint': tintFor(null) } as CSSProperties}
          onClick={() => { haptic(HAPTICS.categoryPick); none.onPick() }}>
          <span className="ml-dot" aria-hidden="true" />
          {none.label}
        </button>
      )}
    </div>
  )
}
